<template>
    <div class="flex w-full justify-center px-8 sm:px-20 py-32 md:py-12">
      <div class="w-full max-w-xl lg:max-w-2xl text-ihh-slate-gray space-y-8 text-base">
        <div class="flex w-full justify-center text-ihh-midnight-gray font-semibold text-3xl text-center">
          Discount Code Terms
        </div>
         <div>Here are the restrictions that apply to our discount code offers:</div>
         <ul class="list-disc pl-6">
           <li>Discount codes cannot be redeemed for cash.</li>
           <li>Discount code savings cannot be applied to gift certificates.</li>
           <li>Discount codes cannot be combined with any other In His Hands discount or offer.</li>
           <li>Discount codes cannot be applied to prior purchases or applied retroactively to orders already placed.</li>
           <li>Limit one use of each discount code per customer.</li>
           <li>Maximum per transaction savings limit of $50.</li>
           <li>Discount codes are subject to minimum order amounts, excluding tax and shipping.</li>
           <li>Discount codes expire at 11:59 p.m. Central Time on the ending day (unless otherwise noted).</li>
           <li>Discount codes may not be transferrable and may only be used by the intended recipient.</li>
           <li>Discount codes can only be used on our website, www.InHisHands.com.</li>
           <li>Discount codes cannot be applied to orders taken over the phone or submitted by email. </li>
         </ul>
         <div class="italic">These terms are subject to change at any time.</div>
      </div>
    </div>
</template>
